export default "__VITE_ASSET__CbN66A5Y__"